// ------------------------------------
// Completa endereço
// ------------------------------------
(function () {
  'use strict';

  // Variáveis
  const urlApi = urlBase + 'store/core/acoes/checkout/completa_endereco.php';
  const $cep = $('#cart-zipcode');
  const $btn = $('#btn-cart-zipcode');
  const btnText = $btn.html();
  const $inputWrapper = $('.cart-ship-res');
  let address = {};

  // Busca o cep ao clicar no botãp
  $btn.on('click', handleAddress);
  function handleAddress() {
    const cepLength = $cep.val().replace(/\D/g, '').length;
    if (cepLength >= 8) {
      getAddress();
    } else {
      $inputWrapper.slideUp();
    }
  }

  // Obtém o endereço completo
  function getAddress() {
    processingAddress();
    // Realiza a requisição dos dados
    console.log(`${urlApi}?cep=${$cep.val()}`);
    $.getJSON(`${urlApi}?cep=${$cep.val()}`, function (result) {
      console.log(result);
      finishedAddress();
      if (result.logradouro) {
        address = result;
        populateAddress();
        $cep.trigger('get-shipping');
      } else {
        showAlert('Atenção', 'Endereço não encontrado!<br> Verifique o CEP informado.', 'warning');
      }
    }).fail(errorAddress);
  }

  // Popula os campos do endereço
  function populateAddress() {
    $('.cart-ship-res-tit b').text(`${address.cidade} / ${address.uf}`);
  }

  // Ações executadas enquanto a requisição é processada
  function processingAddress() {
    $inputWrapper.slideUp();
    $btn.prop('disabled', true).addClass('btn-loader').text('');
    $cep.prop('readonly', true);
  }

  // Ações executadas quanto a requisição é finalizada
  function finishedAddress() {
    $btn.prop('disabled', false).removeClass('btn-loader').html(btnText);
    $cep.prop('readonly', false);
  }

  // Erro na requisição do endereço
  function errorAddress(resp) {
    console.log(resp);
    finishedAddress();
    showAlert('Atenção', 'Endereço não encontrado!<br> Verifique o CEP informado.', 'warning');
  }
})();

// ------------------------------------
// Formas de envio
// ------------------------------------
(function () {
  'use strict';

  // Variáveis
  const $shippingWaysWrp = $('.cart-ship-res');
  const $shippingWays = $('.cart-ship-res-list');
  const $zipcode = $('#cart-zipcode');
  const shippingMethod = $zipcode.data('shipping-method');
  const urlApi = urlBase + 'store/core/acoes/checkout/formas_entrega.php';
  const cartToken = $('[data-cart-token]').data('cart-token');
  const pesoProd = $('#cart-zipcode').data('peso');
  const comprimentoProd = $('#cart-zipcode').data('comprimento');
  const alturaProd = $('#cart-zipcode').data('altura');
  const larguraProd = $('#cart-zipcode').data('largura');
  const prazoProd = $('#cart-zipcode').data('prazo');
  const valorProd = $('#cart-zipcode').data('valor');
  const freteDetalhe = $('#cart-zipcode').data('frete-datelhe');
  const $loader = $('.cart-ship-loader');
  let zipcode;
  let shipping_ways;
  let reqAjax = null;

  // Ao selecionar um forma de envio
  $shippingWays.on('change', 'input', handleChangeShippingWays);
  function handleChangeShippingWays() {
    const $shippingWay = $shippingWays.find('input:checked');
    const shippingWay = $shippingWay.val();
    const title = $shippingWay.data('desc');
    const price = $shippingWay.data('price');
    $shippingWays.data('value', shippingWay);
    if ($('.cart-resume').length > 0) {
      $('.v-cart-frete-desc').text(`Frete (${title})`);
      $('.v-cart-frete').text('R$ ' + formatMoneyBR(price));
    }
    calcCart();
  }

  // Ao alterar o cep de destino
  $zipcode.on('get-shipping', handleShippingWays);

  /* if ($zipcode.val() != '') {
    handleShippingWays();
  } */
  function handleShippingWays() {
    if ($shippingWays.length > 0) {
      zipcode = $zipcode.val();
      if (zipcode != '' && zipcode.length >= 8) {
        getShippingWays();
      }
    }
  }

  // Obtém as formas de entrega
  function getShippingWays() {
    processingSW();
    // Realiza a requisição dos dados
    console.log(`${urlApi}?zipcode=${zipcode}&shipping_gateway=${shippingMethod}&store_token=${publicToken}&cart_token=${cartToken}&peso_prod=${pesoProd}&comprimento_prod=${comprimentoProd}&altura_prod=${alturaProd}&largura_prod=${larguraProd}&prazo_prod=${prazoProd}&valor_prod=${valorProd}&frete_detalhe=${freteDetalhe}&product=${urlBaseLp}&storeId=${baseLanding}`);
    $.getJSON(
      `${urlApi}?zipcode=${zipcode}&shipping_gateway=${shippingMethod}&store_token=${publicToken}&cart_token=${cartToken}&peso_prod=${pesoProd}&comprimento_prod=${comprimentoProd}&altura_prod=${alturaProd}&largura_prod=${larguraProd}&prazo_prod=${prazoProd}&valor_prod=${valorProd}&frete_detalhe=${freteDetalhe}&product=${urlBaseLp}&storeId=${baseLanding}`,
      function (result) {
        console.log(result);
        if (result.status == 'success') {
          shipping_ways = result.shipping_ways;
          populateShippingWays();
        } else {
          errorSW(result);
        }
      },
    ).fail('errorSW');
  }

  // Popula as formas de envio
  function populateShippingWays() {
    $shippingWays.find('.form-group').html('');
    shipping_ways.forEach((way, index) => {
      let checked = '';
      if (($shippingWays.data('value') != '' && $shippingWays.data('value') === way.shipping_way) || index === 0) {
        checked = 'checked';
      } else if (index === 0) {
        checked = 'checked';
      }
      const priceView = Number(way.price) > 0 ? 'R$ ' + formatMoneyBR(Number(way.price)) : 'Grátis';
      const textPrazo = way.text ? ' (' + way.text + ')' : '';
      $shippingWays.find('.form-group').append(`
      <div class="form-check">
        <input type="radio" name="shipping_way" id="co_shipping_way_${way.shipping_way}" value="${way.shipping_way}" data-desc="${way.title}" data-price="${way.price}" ${checked}>
        <label for="co_shipping_way_${way.shipping_way}">${way.title}${textPrazo} - <b>${priceView}</b></label>
      </div>`);
    });
    $shippingWaysWrp.slideDown();
    finishedSW();
  }

  // Ações executadas enquanto a requisição é processada
  function processingSW() {
    $shippingWaysWrp.slideUp();
    $loader.show();
  }

  // Ações executadas quanto a requisição é finalizada
  function finishedSW() {
    $loader.hide();
    handleChangeShippingWays();
  }

  // Erro na requisição
  function errorSW(resp) {
    console.log(resp);
    $loader.hide();
    $shippingWaysWrp.slideUp();
    finishedSW();
  }
})();

// ------------------------------------
// Carrinho
// ------------------------------------

// Variáveis
let cartInfos = $infosBase.data('cart-infos');

// Remove um item do carrinho
(function () {
  'use strict';
  $('body').on('click', '.btn-rem-cart', function (ev) {
    ev.preventDefault();
    const $cartItem = $(this).closest('[data-cart-item]');
    if ($cartItem.length > 0) {
      const cartItem = $cartItem.data('cart-item');
      updateCart(
        {
          acao: 'remove',
          product: cartItem,
        },
        function () {
          getCart(cartInfos.cart_token, function () {
            if (cartInfos.num_rows == 0) {
              location.reload();
            }
          });
        },
      );
    }
  });
})();

// Atualiza a quantidade do carrinho
(function () {
  'use strict';
  $('.pag-cart').on('change', '.ns-input', function (ev) {
    const quantity = $(this).val();
    const $cartItem = $(this).closest('[data-cart-item]');
    const cartItem = $cartItem.data('cart-item');
    updateCart(
      {
        acao: 'update',
        product: cartItem,
        store_id: baseLanding,
        quantity: quantity,
      },
      function () {
        calcCart();
        populateCart();
        populateCartTop();
      },
    );
  });
})();

// Calcula o carrinho
function calcCart() {
  const cartTotal = cartInfos.num_rows;
  const cartItens = cartInfos.result.items;
  let cartAmount = 0;
  let cartSubtotal = 0;
  let cartCustomAmount = 0;
  const cartShip =
    $('input[name="shipping_way"]:checked').length > 0
      ? Number($('input[name="shipping_way"]:checked').data('price'))
      : 0;
  if (cartInfos.num_rows > 0) {
    cartItens.forEach((itemCart, itemCartIndex) => {
      const subtotal = Number(itemCart['product_qtdy']) * Number(itemCart['sale_price']);
      const $cartItem = $('[data-cart-item="' + itemCart['cart_product_id'] + '"]');
      if ($cartItem.length > 0) {
        $cartItem.find('v-cart-subtotal').text('R$ ' + formatMoneyBR(subtotal));
      }
      cartItens[itemCartIndex]['subtotal'] = subtotal;
      cartSubtotal += subtotal;
      cartCustomAmount += itemCart['customizations_amount'];
    });
  }
  cartAmount = cartSubtotal + cartShip;
  $('.v-cart-count').text(cartTotal);
  $('.v-cart-subtotal').text('R$ ' + formatMoneyBR(cartSubtotal));
  $('.v-cart-custom').text('+ R$ ' + formatMoneyBR(cartCustomAmount));
  $('.v-cart-total').text('R$ ' + formatMoneyBR(cartAmount));
}

// Atualiza o carrinho
function updateCart(data, cb = null) {
  const urlApi = urlBase + 'store/core/acoes/themes/boosterstore/carrinho/atualiza_carrinho.php';
  showLoader();
  data.store_token = publicToken;
  data.cart_token = cartInfos.cart_token;
  $.getJSON(`${urlApi}`, data, function (result) {
    console.log(result);
    hideLoader();
    if (result.status === 'success') {
      if (data.acao === 'update') {
        cartInfos = result.cart_body;
      }
      if (cb) {
        cb(result);
      } else {
        calcCart();
      }
    } else {
      showAlert('Erro', 'Não foi possível realizar esta operação.', 'danger');
    }
  }).fail(function (resp) {
    console.log(resp);
    hideLoader();
    showAlert('Erro', 'Não foi possível realizar esta operação.', 'danger');
  });
}

// Obtém carrinho
function getCart(cartToken, cb = null) {
  if (cartToken) {
    const urlApi = urlBase + 'store/core/acoes/themes/boosterstore/carrinho/atualiza_carrinho.php';
    const data = {
      acao: 'view',
      store_id: baseLanding,
      store_token: publicToken,
      cart_token: cartToken,
    };
    $.getJSON(`${urlApi}`, data, function (result) {
      console.log(result);
      if (result.status === 'success') {
        cartInfos = result.cart_body;
        calcCart();
        populateCart();
        populateCartTop();
        if (cb !== null) {
          cb(cartInfos);
        }
      } else {
        console.log('Não foi possível obter o carrinho.');
        cartInfos = false;
      }
    }).fail(function (resp) {
      console.log('Não foi possível obter o carrinho.');
      console.log(resp);
    });
  }
}

// Popula o carrinho
function populateCart() {
  // Variáveis
  const cartTotal = cartInfos.num_rows;
  const cartItens = cartInfos.result.items;
  const $productsList = $('#cart-products-list');
  if ($productsList.length > 0 && cartTotal > 0) {
    $productsList.html('');
    cartItens.forEach((itemCart) => {
      const subtotal = itemCart['subtotal'];
      const $subtitle = itemCart['slug'] != 'u' ? `<div class="cart-prod-text">${itemCart['variant_title']}</div>` : '';
      let progDiscount = 0;
      if (typeof itemCart['progressive_discount'] !== 'undefined') {
        progDiscount = itemCart['progressive_discount'].replace('%', '').replace(',', '.');
      }
      progDiscount = Number(progDiscount);
      const $discBadge = progDiscount > 0 ? `<span class="badge">${itemCart['progressive_discount']} Off</span>` : '';
      const $discBadge2 = $discBadge != '' > 0 ? '<br>' + $discBadge : '';
      let $customInfos = '';
      const $customAmount =
        itemCart['customizations_amount'] > 0
          ? `<small>(+ R$ ${formatMoneyBR(itemCart['customizations_amount'])})</small>`
          : '';
      const $customAmount2 = '<br>' + $customAmount;
      if (itemCart['has_customizations'] == 1) {
        $customInfos += `<div class="cart-prod-custom"><b>Customização</b><ul>`;
        Object.keys(itemCart['customizations_infos']).forEach((csi) => {
          $customInfos += `<li>${itemCart['customizations_infos'][csi]}</li>`;
        });
        $customInfos += `</ul></div>`;
      }
      const $itemCart = `<tr class="cart-table-item" data-cart-item="${itemCart['cart_product_id']}">
        <td>
          <a class="cart-prod">
            <div class="cart-prod-img">
              <figure class="img img-rounded img-border">
                <img src="${itemCart['thumb']}" alt="${itemCart['product_title']}">
              </figure>
            </div>
            <div class="cart-prod-infos">
              <div class="cart-prod-title">${itemCart['product_title']}</div>
              ${$subtitle}
              <div class="cart-prod-price v-item-subtotal">R$ ${formatMoneyBR(subtotal)} ${$discBadge}</div>
              ${$customInfos}
            </div>
          </a>
        </td>
        <td class="center d-none-sm d-none-xs">
          R$ ${formatMoneyBR(itemCart['sale_price'])}
          ${$discBadge2}
        </td>
        <td class="center cart-spinner-wrp text-left-sm text-left-xs mb-sm-0 mb-xs-0">
          <div class="form-group">
            <div class="number-spinner">
              <button class="ns-btn ns-sub"></button>
              <input type="text" inputmode="numeric" name="quantity" class="ns-input number" value="${itemCart['product_qtdy']
        }" min="1" max="50">
              <button class="ns-btn ns-add"></button>
            </div>
          </div>
        </td>
        <td class="center d-none-sm d-none-xs">
          <b class="v-item-subtotal">R$ ${formatMoneyBR(subtotal)}</b>
          ${$customAmount2}
        </td>
        <td class="right btn-rem-cart-wrp">
          <button class="btn btn-sm btn-rem-cart" title="Remover"><svg viewBox="0 0 32 32"><path fill="currentColor" d="M 7.21875 5.78125 L 5.78125 7.21875 L 14.5625 16 L 5.78125 24.78125 L 7.21875 26.21875 L 16 17.4375 L 24.78125 26.21875 L 26.21875 24.78125 L 17.4375 16 L 26.21875 7.21875 L 24.78125 5.78125 L 16 14.5625 Z"></path></svg></button>
        </td>
      </tr>`;
      $productsList.append($itemCart);
    });
    initSpinners();
  }
}

// Popula carrinho topo
function populateCartTop() {
  // Variáveis
  const cartTotal = cartInfos.num_rows;
  const cartItens = cartInfos.result.items;
  const $cartEmpty = $('.dropdown-cart-empty');
  const $cartContent = $('.dropdown-cart-content');
  const $productsList = $('.dropdown-cart-items');
  const $badgeCart = $('.header-cart-btn .badge');
  $productsList.html('');
  if (cartTotal > 0) {
    cartItens.forEach((itemCart) => {
      const $itemCart = `
      <div class="dropdown-cart-item" data-cart-item="${itemCart['cart_product_id']}">
        <div class="dropdown-cart-item-img">
          <img src="${itemCart['thumb']}" alt="${itemCart['product_title']}">
        </div>
        <div class="dropdown-cart-item-infos">
          <div class="dropdown-cart-item-title">${itemCart['product_title']}</div>
          <div class="dropdown-cart-item-price">R$ ${formatMoneyBR(itemCart['subtotal'])}</div>
        </div>
      </div>`;
      $productsList.append($itemCart);
    });
    $badgeCart.removeClass('d-none');
    $cartContent.removeClass('d-none');
    $cartEmpty.addClass('d-none');
    $('.v-cart-url').attr(cartInfos.cart_url);
  } else {
    $badgeCart.addClass('d-none');
    $cartContent.addClass('d-none');
    $cartEmpty.removeClass('d-none');
  }
}
